// Error message processing

// Unpack request errors and return either JSON-API error messages or plain
// error message
const unpack = (error) => {
  const isJsonApiError = (
    error.response &&
    error.response.data &&
    error.response.data.errors
  )

  if (isJsonApiError) {
    // Put all errors together in a string
    return error.response.data.errors.map(
      // if detail and title are roughly the same, just return title
      // else return title: detail
      (err) => (
        String(err.detail).match(err.title) ?
        err.title :
        `${err.title}: ${err.detail}`
      )
    ).join(', ')
  }
  else {
    return error.message  // Other errors
  }
}

const errors = {
  unpack
}

export default errors



// WEBPACK FOOTER //
// ./src/lib/errors.js